const locale = {
  placeholder: 'VÃ¤lj tid',
};

export default locale;
